import SkeletonLoader from './index';

const TeacherProfileSkeleton = () => {
  return (
    <div className="w-full max-w-216 flex flex-col gap-6">
      <SkeletonLoader width={200} height={28} />

      <div className="p-6 border border-neutral-light-200 rounded-2xl flex flex-col gap-6 bg-white">
        <div className="flex flex-col gap-4">
          <SkeletonLoader width={220} height={20} />

          <div className="pb-6 border-b border-neutral-light-200 flex flex-col sm:flex-row items-center gap-10">
            <SkeletonLoader variant="circle" width={100} height={100} />

            <div className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-10 w-full">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex flex-col gap-2">
                  <SkeletonLoader width={120} height={16} />
                  <SkeletonLoader width="100%" height={20} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4">
          <SkeletonLoader width={160} height={20} />

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="flex gap-4 p-4 py-2 items-center bg-white border border-neutral-light-200 rounded-lg"
              >
                <SkeletonLoader variant="circle" width={48} height={48} />
                <div className="flex flex-col gap-2 w-full">
                  <SkeletonLoader width="70%" height={16} />
                  <SkeletonLoader width="50%" height={16} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherProfileSkeleton;
